import { useQuery } from '@tanstack/react-query';

import { REQUEST_STALE_TIME_IN_MS } from '@/constants';
import { filesQueryKeys } from '@/data/services/querykeys';

const toSize = (contentLength?: string) => {
  const size = Number(contentLength);

  return size > 0 ? size : undefined;
};

export default function usePdfFile(url: string) {
  const { data, isInitialLoading, isError, refetch } = useQuery({
    ...filesQueryKeys.head(url),
    staleTime: REQUEST_STALE_TIME_IN_MS,
  });

  return {
    size: toSize(data?.headers['content-length']),
    isLoading: isInitialLoading,
    isError,
    refetch,
  };
}
